import { FC, Fragment, ReactElement } from 'react'

import { TableCell, TableRow } from '../../../../components'
import { EventLogDataItem } from '../../../../entities/EventLog/EventLog'
import { generateUuid } from '../../../../helpers/string'
import trans from '../../../../helpers/trans'
import { ValkTable } from '../../../index'
import { convertToCategories, convertToCategoryItems } from '../../helpers'

import './PzLogDataTable.scss'

interface PzLogDataTableProps {
    dataItems: EventLogDataItem[];
    className?: string;
}

const PzLogDataTable: FC<PzLogDataTableProps> = ({
    dataItems,
    className = '',
}): ReactElement => (
    <ValkTable<EventLogDataItem>
        hasRowClick
        rows={dataItems}
        tableHeaders={[trans('compositions.pzLogDetail.subject'), trans('compositions.pzLogDetail.change')]}
        className={`pz-log-data-table ${className}`}
        tableClassName="pz-log-data-table__table"
        cellClassName="pz-log-data-table__table-cell"
        headerRowClassName="pz-log-data-table__header-row"
    >
        {pzLogs => (
            pzLogs.flatMap(log => {
                const categories = convertToCategories(log)

                return categories.map(({ key, value }) => {
                    const items = convertToCategoryItems(key, value)

                    return (
                        <Fragment key={generateUuid()}>
                            {items.map(({ category, change }) => {
                                const categoryItem = trans(`entities.eventLog.categoryItem.${category}`)

                                return (
                                    <TableRow key={generateUuid()} className={`pz-log-data-table__subrow ${className}`}>
                                        <TableCell className="pz-log-data-table__value-cell">
                                            {categoryItem}
                                        </TableCell>

                                        <TableCell className="pz-log-data-table__value-cell">
                                            {change}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </Fragment>
                    )
                })
            })
        )}

    </ValkTable>
)

export default PzLogDataTable
